import React from 'react';
import {Container, Typography} from '@mui/material';
import {ArrowDownward} from '@mui/icons-material';
import TopTier from './topTier/TopTier';
import './testimonials.css'
import TestimonialItemList from './TestimonialItemList';
import {styled} from "@mui/material/styles";

const TestimonialsDescription = styled(Typography)(({theme}) => ({
  color: theme.palette.text.disabled,
}));

const Testimonials = () => {
    return (
        <section>
            <Container>
                <div className="ss-customer-partner-testimonials-parent">
                    <ArrowDownward className='ss-testimonial-arrow-icon' fontSize='large' />
                    <div className="ss-customer-partner-testimonials-head">
                        <Typography variant="h3" color="textPrimary">Supported by top-tier buyers and suppliers across the globe</Typography>
                        <TestimonialsDescription variant="overline">Testimonials</TestimonialsDescription>
                    </div>
                    <TestimonialItemList />
                    <TopTier />
                </div>
            </Container>
        </section>
    )
}

export default Testimonials;
